import axios from "axios";
import { isTokenExpired } from "../utils/isTokenExpired";

// const BASE_URL = "http://localhost:5000/api";
const BASE_URL = "https://api.grantnest.eu/api";

const HTTP = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

let getToken = () => null;
let logoutHandler = null;

export const setLogoutHandler = (fn) => {
  logoutHandler = fn;
};

export const setTokenGetter = (getterFn) => {
  getToken = getterFn;
};

HTTP.interceptors.request.use(
  (config) => {
    if (config.url.includes("/auth/login")) {
      return config;
    }

    const token = getToken();

    if (!token) {
      return config;
    }

    if (isTokenExpired(token)) {
      console.warn(
        "Session expired. Clearing state and redirecting to login...",
      );
      try {
        if (typeof logoutHandler === "function") {
          logoutHandler();
        } else {
          window.location.href = "/";
        }
      } catch (e) {
        console.warn("Failed to run logout handler", e);
        window.location.href = "/";
      }
      return Promise.reject(new Error("Session expired"));
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

// handle 401 responses globally: clear auth and redirect to login
HTTP.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      try {
        if (typeof logoutHandler === "function") {
          logoutHandler();
        } else {
          window.location.href = "/";
        }
      } catch (e) {
        console.warn("Failed to run logout handler on 401", e);
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  },
);

export default HTTP;
